import "./Privacy.css"; 

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container container py-5">
            <h1 className="text-center fw-bold mb-3">Privacy Policy </h1>
            <p className="text-center text-muted mb-4">Last updated: 9th Jan 2025</p>

            <section>      
                <p>
                    At (&quot;BooksComply,&quot; &quot;we,&quot; &quot;us&quot;), we prioritize the privacy of users (&quot;you,&quot; &quot;User&quot;) who
                    interact with our website <a href="https://BooksComply.com/" target="_blank" rel="noopener noreferrer" className="text-primary">
                        https://BooksComply.com/
                    </a>{" "} (the &quot;Website&quot;) and utilize the services described on the
                    Website (the &quot;Services&quot;). This Privacy Policy explains the types of personal information
                    (&quot;Personal Information&quot;) we collect, how we use and disclose it, and your rights regarding
                    your data. &quot;Personal Information&quot; includes information that identifies, relates to, describes, or
                    could reasonably be linked to an individual.
                </p>

                <p>
                    By using the Website and Services, you agree to the terms of this Privacy Policy. If you do
                    not agree, please discontinue your use of the Website and Services.
                </p>
            </section>

            <section>
                <h2 className="section-title">I. Collecting Personal Information</h2>

                <h4 className="section-subtitle">a) Signing Up and Using the Services:</h4>
                <p>
                    When you sign up and use the Services, we may collect the following Personal Information:
                </p>
                <ul className="privacy-list">
                    <li>Name</li>
                    <li>Email Address</li>
                    <li>Username</li>
                    <li>Password</li>
                    <li>Phone number</li>
                    <li>Other required details during sign-up</li>
                </ul>

                <p>
                    We collect this information to authenticate your identity and provide personalized services.
                    The information you provide during the sign-up process helps us improve your overall user
                    experience, and we may contact you for feedback or suggestions to enhance our services.
                </p>

                <p>
                    When using the Website and/or Services, you are responsible for the information you choose
                    to share. Please use discretion and care when sharing details that could allow others to
                    identify or locate you. By using the Website and/or Services, you acknowledge that any
                    information you post or provide is shared voluntarily. While we implement reasonable
                    security measures, we cannot guarantee the confidentiality of the information you disclose
                    through the Website and/or Services.
                </p>

            </section>

            <section>
                <h4 className="section-subtitle">b) Communication with Us</h4>
                <p>
                    When you interact with us through the Website and/or Services, send us emails, or otherwise
                    communicate with us, we may collect the following identifiers which, either on their own or
                    combined with other details, may qualify as Personal Information:
                </p>

                <ul className="privacy-list">
                    <li>Name</li>
                    <li>Email Address</li>
                    <li>The content of your messages</li>
                </ul>

                <p>This information helps us respond to your inquiries, provide customer support, and improve
                    our Services. Additionally, we may use it for follow-up communication, offer product
                    updates, or resolve any issues you encounter.</p>

            </section>

            <section>
                <h4 className="section-subtitle">c) Automatically Collected Information</h4>
                <p>
                    We automatically collect technical data during your use of the Website, such as:
                </p>
                <ul className="privacy-list">
                    <li>IP address</li>
                    <li>Browser type</li>
                    <li>Operating system</li>
                    <li>Pages visited and time spent</li>
                    <li>Browser type</li>
                    <li>Session details</li>
                </ul>

                <p>This data is gathered to analyze user behavior, improve the performance of the Website, and
                    ensure its security. It helps us understand how you interact with the Website, and it can also
                    be used for debugging, analyzing trends, and improving our services.
                </p>

                <p>This data may be collected through tools like cookies, web beacons, and Google Analytics.
                    You can adjust your browser settings to limit or block cookies, but doing so may affect the
                    functionality of the Website.
                </p>

            </section>

            <section>

                <h4 className="section-subtitle">d) Non-Personal Information</h4>
                <p>
                    We may also collect non-personal information that cannot directly identify you, such as
                    aggregated usage statistics. These statistics include metrics like the number of visitors to a
                    specific page or the overall usage of our features, helping us assess performance and improve
                    the user experience.
                </p>

            </section>

            <section>

                <h4 className="section-subtitle">e) Use of AI Technologies</h4>
                <p>
                    We may employ AI tools for tasks like data analysis and support. These tools process data
                    solely for providing Services and do not retain or reuse your information for other purposes.
                    AI tools help us analyze trends, predict potential issues, and enhance our customer service,
                    making our platform more efficient and user-friendly.
                </p>

            </section>

            <section>
                <h2 className="section-title">II. Purpose of Collecting Personal Information</h2>
                <p>We collect Personal Information to:</p>
                <ul className="privacy-list">
                    <li>Operate and improve the Website and Services</li>
                    <li>Personalize your experience based on preferences and behavior</li>
                    <li>Respond to inquiries and requests</li>
                    <li>Send administrative updates, such as changes to the Terms of Service or Privacy Policy</li>
                    <li>Provide customer support, resolve issues, and offer relevant product recommendations</li>
                </ul>

                <p>
                    We may also use the information to tailor marketing messages and inform you of new
                    features or services that may interest you, based on your interactions with the Website.
                </p>

            </section>

            <section>
                <h2 className="section-title">III. Sharing Personal Information</h2>
                <p>We may share your Personal Information in the following cases:</p>

                <h4 className="section-subtitle">a) Service Providers</h4>
                <p>
                    We engage third-party service providers to support our operations (e.g., hosting, payment
                    processing). These providers have access to your data only as necessary to perform their
                    functions and are required to comply with confidentiality agreements and applicable laws.
                </p>

            </section>

            <section>

                <h4 className="section-subtitle">b) Compliance and Legal Obligations</h4>
                <p>
                    We may disclose data to comply with legal requests or protect our rights, including
                    responding to subpoenas, court orders, or other legal processes. We may also share
                    information in cases of fraud, cybersecurity threats, or violations of our policies.
                </p>

            </section>

            <section>
                <h4 className="section-subtitle">c) Business Transfers</h4>
                <p>
                    In the event of mergers, acquisitions, or other corporate transactions, your data may be
                    transferred as part of the business assets. We will notify you via email or through a notice on
                    the Website about such changes and the choices available to you.
                </p>

                <h4 className="section-subtitle">d) Advertising</h4>
                <p>
                    Non-personal data may be shared with advertising partners to deliver targeted ads. This
                    information may include your interests or online behavior to provide ads that are more
                    relevant to you. You can control some of this by adjusting your preferences in your browser
                    or ad settings.
                </p>
            </section>

            <section>
                <h2 className="section-title">IV. Social Media Features</h2>

                <p>
                    Our Website may integrate features like social media buttons (e.g., Facebook, LinkedIn).
                    These platforms may collect your data, such as IP address and browsing behavior. Your
                    interactions with these features are governed by their respective privacy policies. We do not
                    control the data collected by social media platforms. It is recommended that you review the
                    privacy policies of these third-party sites before engaging with them.
                </p>

                <h2 className="section-title">V. Your Rights &amp; Choices</h2>

                <p>
                    You have the right to:
                </p>

                <ul className="privacy-list">
                    <li>Access, update, or delete your Personal Information through your account settings or by
                        contacting us directly.</li>
                    <li>Opt-out of direct marketing communications at any time by following the unsubscribe
                        instructions in the emails we send.</li>
                    <li>Restrict certain data processing activities, including opting out of data analytics or sharing
                        with third-party partners.</li>
                    <li>Request the transfer of your data to another service, where applicable, in accordance with
                        data portability rights.</li>
                </ul>
                <p>To exercise your rights, contact us using the details below. We will respond to your request in
                    accordance with applicable laws.</p>

            </section>

            <section>
                <h2 className="section-title">VI. Data Security</h2>
                <p>
                    We implement reasonable measures to secure your data. However, no system is completely
                    secure, and we cannot guarantee absolute protection. We use encryption and access controls
                    to safeguard your information and regularly monitor our systems for potential vulnerabilities.
                </p>
                <p>
                    You are also responsible for keeping your account information, including your password,
                    secure. We recommend that you use strong, unique passwords and avoid sharing your login
                    details with others.
                </p>

            </section>

            <section>
                <h2 className="section-title">VII. Changes to This Privacy Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. Updates will be posted on this page
                    with the &quot;Last updated&quot; date. We encourage you to periodically review this policy to stay
                    informed about how we are protecting your personal data. If we make material changes to
                    this Privacy Policy, we will notify you via email or post a prominent notice on the Website.
                </p>

            </section>
        </div>
    );
};

export default PrivacyPolicy;
